import React from "react";
import style from "./index.module.scss";
import { formatMediaName, getWeekDay } from "@/common/utils";

function RewardDetails(props) {

  const filterTime = (str) => {
    let time1 = str.slice(0, 10);
    time1 = new Date(time1).toDateString().split(" ").map((item, index) => {
      if (index === 1 || index === 2) { return ` ${item}`; }
      else return "";
    }).join("");
    let time2 = str.slice(13);
    time2 = new Date(time2).toDateString().split(" ").map((item, index) => {
      if (index === 1 || index === 2) { return ` ${item}`; }
      else return "";
    }).join("");
    return `${time1} -${time2}`.trim();
  };

  const getLastWeek = () => {
    const now = new Date();
    const lastWeekNow = new Date(now.getTime() - 7 * 24 * 3600 * 1000);
    const t1 = getWeekDay(1, lastWeekNow);
    const t2 = getWeekDay(0, now);
    return `${t1} - ${t2}`;
  };

  const getLast4Week = () => {
    const now = new Date();
    const last4WeekNow = new Date(now.getTime() - 5 * 7 * 24 * 3600 * 1000);
    const last3WeekNow = new Date(now.getTime() - 4 * 7 * 24 * 3600 * 1000);
    const t1 = getWeekDay(1, last4WeekNow);
    const t2 = getWeekDay(0, last3WeekNow);
    return `${t1} - ${t2}`;
  };

  const time1 = (props.data && props.data.weekBill && filterTime(props.data.weekBill.period)) || filterTime(getLastWeek());
  const time2 = (props.data && props.data.compensateBill && filterTime(props.data.compensateBill.period)) || filterTime(getLast4Week());

  return (
    <div className={`${style.detail_content}`}>
      <div className={style.back} onClick={props.back}></div>
      <div className={style.title}>REWARDS EXPLAINED</div>
      <div className={style.rewardContent}>
        <div className={style.rewardTableBox}>
          <div className={style.tableBoxText}>
            <p className={style.text1}>List of Your Videos</p>
            <p className={style.text2}>Settlement Period: {time1}</p>
          </div>
          <div className={style.tableBoxText2}>
            <p className={style.text3}>Only videos published during this period will be counted.</p>
          </div>
          {
            (props.data && props.data.weekBill && props.data.weekBill.contents && props.data.weekBill.contents.length) ? (
              <div className={style.rewardTable}>
                <ul className={style.table_head}>
                  <li>Content Title</li>
                  <li>Views</li>
                  <li>Publish Date</li>
                  <li>Channel</li>
                </ul>
                <div className={style.table_body}>
                  {
                    props.data.weekBill.contents.map(item => (
                      <ul key={item.id}>
                        <li>{item.title}</li>
                        <li>{item.viewCount}</li>
                        <li>{(item.publishTime || item.updatedTime).slice(0, 10)}</li>
                        <li>{formatMediaName(item.mTag)}</li>
                      </ul>
                    ))
                  }
                </div>
              </div>
            ) : (
              <div className={style.noData}>
                <p>No data</p>
              </div>
            )
          }
          <div className={style.bounBox}>
            <p>Period Diamond Rewards : <span><em>{(props.data && props.data.weekBill && props.data.weekBill.reward) || 0}</em> DIAMOND</span></p>
          </div>
        </div>
        <div className={style.slice}></div>
        <div className={style.rewardTableBox}>
          <div className={style.tableBoxText}>
            <p className={style.text1}>List of Your Videos</p>
            <p className={style.text2}>Settlement Period: {time2}</p>
          </div>
          <div className={style.tableBoxText2}>
            <p className={style.text3}>Only videos published during this period will be counted.</p>
          </div>
          {
            (props.data && props.data.compensateBill && props.data.compensateBill.contents && props.data.compensateBill.contents.length) ? (
              <div className={style.rewardTable}>
                <ul className={style.table_head}>
                  <li>Content Title</li>
                  <li>Views</li>
                  {/* <li>New Views added</li> */}
                  <li>Publish Date</li>
                  <li>Channel</li>
                </ul>
                <div className={style.table_body}>
                  {
                    props.data.compensateBill.contents.map(item => (
                      <ul key={item.id}>
                        <li>{item.title}</li>
                        <li>{item.viewCount}</li>
                        {/* <li>{item.viewInc || 0}</li> */}
                        <li>{(item.publishTime || item.updatedTime).slice(0, 10)}</li>
                        <li>{formatMediaName(item.mTag)}</li>
                      </ul>
                    ))
                  }
                </div>
              </div>
            ) : (
              <div className={style.noData}>
                <p>No data</p>
              </div>
            )
          }
          <div className={style.bounBox}>
          {
              (props.data && props.data.compensateBill) ? (
                <>
                  {
                    props.data.compensateBill.oldCalcReward ? (
                      <>
                        <p>Period Diamond Rewards : 
                          <p className={style.right}>
                            <span>
                              <em className={style.pre}>{(props.data.compensateBill.oldCalcReward) || 0}</em> <span className={style.pre}>DIAMOND</span>
                              <em>&nbsp;+&nbsp;{(Math.max((props.data.compensateBill.calcReward || 0), (props.data.compensateBill.oldCalcReward || 0)) - (props.data.compensateBill.oldCalcReward || 0))}</em> DIAMOND
                            </span>
                          </p>
                        </p>
                      </>
                    ) : (
                      <>
                        <p>Period Diamond Rewards : <span><em>{props.data.compensateBill.reward || 0}</em> DIAMOND</span></p>
                      </>
                    )
                  }
                </>
              ) : (
                <>
                  <p>Period Diamond Rewards : <span><em>0</em> DIAMOND</span></p>
                </>
              )
            }
          </div>
        </div>
        <div className={style.question}>
          <p>Settlement Day: {props.setTime}</p>
          <p>The views data is based on the data recorded by the social media platform on the <em>settlement day</em>. If you have doubts about this reward detail, please contact the captain / customer service on Discord.</p>
        </div>
      </div>
    </div>
  );
}

export default RewardDetails;
